<template>
  <div class="flex flex-col bg-white rounded-sm text-gray mx-2 my-3 p-2">
    <div class="mb-4 border-b border-gray-200">
      <nav class="flex space-x-6 px-4" aria-label="Tabs">
        <div :class="[currentRoute === 'transactions' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('transactions')">
        Transactions
        </div>
        <div :class="[currentRoute === 'incorporation' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('incorporation')">Incorporation Invoices
        </div>
      </nav>
    </div>
    <div>
      <TransactionsList v-if="currentRoute === 'transactions'" />
      <IncorporationInvoices v-if="currentRoute === 'incorporation'" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import TransactionsList from "./TransactionsList.vue";
import IncorporationInvoices from "./IncorporationInvoices.vue";

const currentRoute = ref("transactions");
const select = (route: string) => {
  currentRoute.value = route;
};
</script>
